// Mesma regra do backend (TaskAttachmentRequest::fileRules, F-23): extensão da lista e até 20MB.
// Se a lista mudar lá, mude aqui. O servidor continua sendo quem decide; isto só evita o envio
// e diz ao usuário qual arquivo foi recusado e por quê.
export const TASK_ATTACHMENT_ALLOWED_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'txt',
  'csv',
  'zip',
]

export const MAX_TASK_ATTACHMENT_BYTES = 20 * 1024 * 1024

// Valor para o atributo `accept` do <input type='file'>.
export const TASK_ATTACHMENT_ACCEPT = TASK_ATTACHMENT_ALLOWED_EXTENSIONS.map((ext) => `.${ext}`).join(',')

function getExtension(fileName: string): string {
  const dot = fileName.lastIndexOf('.')
  return dot >= 0 ? fileName.slice(dot + 1).toLowerCase() : ''
}

/** Texto da recusa (igual ao do servidor) ou null se o arquivo pode ser enviado. */
export function getTaskAttachmentError(file: File): string | null {
  const reasons: string[] = []

  if (!TASK_ATTACHMENT_ALLOWED_EXTENSIONS.includes(getExtension(file.name))) {
    reasons.push(
      `O tipo do arquivo não é permitido. Tipos aceitos: ${TASK_ATTACHMENT_ALLOWED_EXTENSIONS.join(', ')}.`
    )
  }
  if (file.size > MAX_TASK_ATTACHMENT_BYTES) {
    reasons.push('O arquivo não pode ser maior que 20MB.')
  }

  return reasons.length > 0 ? `O arquivo "${file.name}" foi recusado. ${reasons.join(' ')}` : null
}
